import { API_URLS } from "../constants";
import { getRequest, postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { USER_RESPONSES } = API_URLS;

const exportDetailCustomerSurveyData = (fromDate, toDate, brandId) => {
  return getRequest(
    `${USER_RESPONSES.EXPORT_BRAND_SURVEY_RESPONSES}?brandId=${brandId}&fromDate=${encodeURIComponent(
      fromDate,
    )}&toDate=${encodeURIComponent(toDate)}`,
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response),
  );
};

const getAverageRatingResponses = (payload) => {
  return postRequest(USER_RESPONSES.GET_AVERAGE_RATING_RESPONSES, payload).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response),
  );
};

const getRecordPaginationResponses = (payload) => {
  return postRequest(
    USER_RESPONSES.GET_RECORD_PAGINATION_RESPONSES,
    payload,
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response),
  );
};

export const brandPerformanceService = {
  getAverageRatingResponses,
  getRecordPaginationResponses,
  exportDetailCustomerSurveyData,
};
